var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account-addresses" },
    [
      _c(
        "div",
        { staticClass: "delivery-addresses" },
        [
          _c(
            "div",
            { staticClass: "title" },
            [
              _c("f-sprite-icon", {
                attrs: { "icon-link": _vm.$options.icons.IconBox.id }
              }),
              _c("h2", [_vm._v("Адреса доставки")])
            ],
            1
          ),
          _vm.sortedAddresses.length !== 0
            ? _c(
                "div",
                { staticClass: "list" },
                [
                  _vm._l(_vm.sortedAddresses, function(address) {
                    return _c("address-card", {
                      key: address.id,
                      attrs: { address: address },
                      on: {
                        "on-primary": function($event) {
                          return _vm.setPrimary(address)
                        },
                        "on-edit": function($event) {
                          return _vm.openAddressModal(address)
                        },
                        "on-removed": _vm.LOAD_ADDRESSES
                      }
                    })
                  }),
                  _c(
                    "div",
                    [
                      _vm.ADDRESSES.length >= 10
                        ? _c(
                            "ui-notification",
                            {
                              staticClass: "limit",
                              attrs: {
                                title:
                                  "Невозможно добавить более 10 адресов доставки",
                                color: "#FFB71B"
                              }
                            },
                            [
                              _vm._v(
                                "\n          Отредактируйте текущие или удалите лишние\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _c("address-card", {
                        attrs: {
                          button: "Добавить адрес",
                          disabled: _vm.ADDRESSES.length >= 10
                        },
                        on: {
                          open: function($event) {
                            return _vm.openAddressModal(_vm.defaultAddress)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            : _c(
                "page-info",
                {
                  staticClass: "page-info",
                  attrs: {
                    title: "Список адресов пуст",
                    subtitle:
                      "Добавьте адрес доставки, чтобы использовать его при оформлении заказа"
                  }
                },
                [
                  _c("ui-button", {
                    attrs: { text: "Добавить адрес" },
                    on: {
                      click: function($event) {
                        return _vm.openAddressModal(_vm.defaultAddress)
                      }
                    }
                  })
                ],
                1
              )
        ],
        1
      ),
      false
        ? _c("div", { staticClass: "favourite-shops" }, [
            _c(
              "div",
              { staticClass: "title" },
              [
                _c("f-sprite-icon", {
                  attrs: { "icon-link": _vm.$options.icons.IconPoint.id }
                }),
                _c("h2", [_vm._v("Избранные магазины")])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "list" },
              [
                _c(
                  "address-card",
                  {
                    attrs: {
                      title: "БЦ «Водный стадион»",
                      description: "Москва, Волгоградский пр-кт 26/1, 2 этаж"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        attrs: { slot: "button" },
                        on: {
                          click: function($event) {
                            _vm.openedAddressModal = true
                          }
                        },
                        slot: "button"
                      },
                      [
                        _c("f-sprite-icon", {
                          attrs: {
                            slot: "button",
                            "icon-link": _vm.$options.icons.IconBin.id
                          },
                          slot: "button"
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c("address-card", {
                  attrs: { button: "Добавить магазин" },
                  on: {
                    open: function($event) {
                      _vm.openedAddressModal = true
                    }
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "modal",
        {
          attrs: { visible: _vm.openedAddressModal },
          on: {
            "on-close": function($event) {
              _vm.openedAddressModal = false
            }
          }
        },
        [
          _c("address-form", {
            attrs: {
              address: _vm.editableAddress,
              "change-primary": _vm.ADDRESSES.length >= 1
            },
            on: {
              "on-close": function($event) {
                _vm.openedAddressModal = false
              },
              success: _vm.successForm
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }